import styled from 'styled-components';

import { GRADIENTS, HOME, HOME_NARROW } from '../../../../theme/tokens';

/** Stats column on the left, trend chart + legend on the right. Collapses to one
 *  column at 1120px. */
export const Inner = styled.div`
  background: ${HOME.panel};
  border-radius: 16px;
  padding: 12px;
  display: grid;
  grid-template-columns: minmax(220px, 0.9fr) 1.3fr;
  gap: 24px;

  > * {
    min-width: 0;
  }

  ${HOME_NARROW} {
    grid-template-columns: 1fr;
  }
`;

/** Registration | FTDs, split by a vertical hairline. */
export const StatsRow = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 20px;
`;

export const Cell = styled.div`
  flex: 1;
  min-width: 0;
`;

export const VDivider = styled.div`
  flex: 0 0 1px;
  align-self: stretch;
  background: ${GRADIENTS.dividerStyledV};
`;

export const ChartCol = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 0;
`;

export const LegendWrap = styled.div`
  margin-top: 8px;
`;
